import { Injectable, Directive, EventEmitter } from '@angular/core';
import { IvSignService } from '../api';
import { PersonalizationsService } from '../base/services/personalizations/personalizations.service';
import { TranslateService } from '../core/translation';
import { Environment } from '../models/environment';
import { MessageService } from '../shared/message/message.service';

@Directive()
@Injectable()
export class SamlService {

  environment: Environment;
  tokenIvSign: EventEmitter<string> = new EventEmitter();
  hasTokenSAML: EventEmitter<boolean> = new EventEmitter();

  constructor(
    public _personalization: PersonalizationsService,
    public _ivsign: IvSignService,
    public _translate: TranslateService,
    public _message: MessageService
  ) {
    this.environment = this._personalization.sendEnv;
   }

  public routeSAML(idOperation: string): void {
    const companyName = this.environment?.login.orgaID;
    if (companyName) {
        this._ivsign.ivSignPostLoginSAML(companyName, '', idOperation).subscribe(response => {
            window.location.replace(response.url);
        }, (error: any) => {
            this._message.showError(error);
        });
    } else {
        this._message.showError(this._translate.instant('saml_error_configuracion'));
    }
  }

}
